import { render, staticRenderFns } from "./huiTalk.vue?vue&type=template&id=a0d449d4&scoped=true"
import script from "./huiTalk.vue?vue&type=script&lang=js"
export * from "./huiTalk.vue?vue&type=script&lang=js"
import style1 from "./huiTalk.vue?vue&type=style&index=1&id=a0d449d4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0d449d4",
  null
  
)

export default component.exports